export const socialLinks = [
	{
		id: 1,
		name: 'Website',
		icon: 'globe',
		url: 'https://portfolioo-eta-three.vercel.app/',
	},
	{
		id: 2,
		name: 'GitHub',
		icon: 'github',
		url: 'https://github.com/Colifaa',
	},
	{
		id: 3,
		name: 'Twitter',
		icon: 'twitter',
		url: 'https://x.com/Jorgemathez14',
	},
	{
		id: 4,
		name: 'LinkedIn',
		icon: 'linkedin',
		url: 'https://www.linkedin.com/in/jorge-mathez/',
	},
	
];
